import { useState } from "react"
//styles
import './Dashboard.css'

import {useCollection} from '../../hooks/useCollection'
import { ProjectList } from '../../components/ProjectList'
import { ProjectFilter } from './ProjectFilter'

import {useAuthcontext} from '../../hooks/useAuthcontext'

const Dashboard = () => {
  const {user} = useAuthcontext()
  const[currentFilter,setCurrentFilter] = useState('all')
  const { document, error, pending} = useCollection('projects')
  const changeFilter = (newFilter) => {
    setCurrentFilter(newFilter)
  }
  const projects = document ? document.filter((document)=>{
    switch(currentFilter){
      case 'all':
        return true
      case 'mine':
        let assignedToMe = false
        document.assignedUsersList.forEach((u) => {
          if (user.uid === u.id) {
            assignedToMe = true
          }
        })
        return assignedToMe
        case 'development':
        case 'design':
        case 'sales':
        case 'marketing':
          console.log(document.category, currentFilter)
          return document.category === currentFilter
        default:
          return true
    }
  }) : null
  return (
    <div>
      <h2 className='page-title'>Dashboard</h2>
      {pending && <p>Loading ...</p>}
      {error && <p className='error'>{error}</p>}
      {document && <ProjectFilter currentFilter = {currentFilter} changeFilter = { changeFilter }/>}
      {projects && <ProjectList projects = {projects}/>}
    </div>
  )
}

export default Dashboard
